import { authFecth } from "../scripts/requests";
import { projectEndpoint } from "../variables/services";

export const get_project_name = async (setProjectName, project_id) => {
        await authFecth(`${projectEndpoint}/project`, "GET", {project_id: project_id})
        .then(res => {
            if (!res.ok) { 
            return res.json().then(data => {
                throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
            });
            }
            return res.json();
        })
        .then(data => {
            setProjectName(data.name)
        })
        .catch(error => {
            console.error("Error fetching user:", error);
        });
        
    }